module.exports = __webpack_public_path__ + "static/img/(Banner-4月10日）第一届细菌感染峰会－微网站-2.9-41.f6b18097.jpg";